// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"20293840","330":"5671cb77","415":"34c2a5da","890":"a4037ca6"}[chunkId] + ".chunk.js";
};